import React from 'react';
import { Button, Grid, Typography } from '@mui/material';
import KeyboardArrowRightRoundedIcon from '@mui/icons-material/KeyboardArrowRightRounded';
import { HotLabel } from '../../views/AdviserHomePage/HotLabel/HotLabel';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
/**
 * @param {string} title
 * @param {React.ReactNode} icon
 * @param {() => void} onClick
 * @param {boolean} isHot
*/

const MainFloatingButton = ({ title, icon, onClick, isHot = false, hotLabelText = 'hot', ButtonProps }) => {
    const theme = useTheme();
    const isWideLayout = useMediaQuery(theme => theme.breakpoints.up("md"));

    return (
        <Button
            className="main-floating-button"
            onClick={onClick}
            fullWidth
            style={{
                padding: 0,
                maxHeight: 'none',
            }}
        >
            <Grid container style={{
                ...ButtonProps?.style,
            }} sx={{
                alignItems: "stretch"
            }}>
                <Grid style={{
                        padding: 3,
                        background: 'var(--new-theme)',
                        borderRadius: '8px 0 0 8px'
                    }}></Grid>

                <Grid style={{
                    flexGrow: 1,
                    paddingLeft: isWideLayout ? 10 : 8,
                    paddingRight: isWideLayout ? 20 : 8,
                    boxShadow: '2px 5px 11.5px rgba(89, 89, 198, 0.3)',
                    borderRadius: '0 8px 8px 0'
                }}>
                    <Grid container style={{ height: '100%', width: '100%' }} sx={{
                        alignItems: "center"
                    }}>
                        <Grid style={{ flexGrow: 1 }}>
                            <Grid
                                container
                                spacing={1}
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                <Grid>
                                    <Grid container sx={{
                                        alignItems: "center"
                                    }}>
                                        <Grid style={{ height: 25 }}>
                                            {icon}
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid>
                                    <Typography style={{ fontSize: '120%', fontWeight: '600' }}>
                                        {title}
                                    </Typography>
                                </Grid>
                                {isHot && (
                                    <Grid>
                                        <HotLabel
                                            text={hotLabelText}
                                            style={{ position: 'relative', borderRadius: 4, padding: '0 4px', top: 0, left: 0 }}
                                        />
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                        <Grid>
                            <KeyboardArrowRightRoundedIcon
                                style={{
                                    verticalAlign: 'middle',
                                    borderRadius: '50%',
                                    fontSize: 20,
                                    background: 'var(--new-theme)',
                                    fill: theme.palette.primary.contrastText
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Button>
    );
};

export default MainFloatingButton;
